module.exports = __webpack_public_path__ + "static/img/pro7.7abd4823.png";